import { render } from "./PaymentInstallmentsType.vue?vue&type=template&id=c5762c1a"
import script from "./PaymentInstallmentsType.vue?vue&type=script&lang=js"
export * from "./PaymentInstallmentsType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__